import RegisterChangeDataStore from '../../datastores/RegisterChangeDataStore';

export default class RegisterChangeDataStoreMock
  implements RegisterChangeDataStore
{
  async register(
    procedureId: number,
    modalityCode: string,
    modalityName: string,
    newPeriod: string
  ) {
    if (procedureId === 1031) {
      return {
        requestId: 15,
        error: null
      };
    }
    const data = {
      requestId: 1000,
      error: null,
      modalityCode,
      modalityName,
      newPeriod
    };
    return data;
  }
}
